<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Body with tabs following F7004 pattern -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>

        <!-- Entity information table -->
        <table class="table table-bordered form-inline enityDetails custom-table">
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.key }}</span>
            </td>
}
          </tr>
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.value }}</span>
            </td>
}
          </tr>
        </table>
        
        <!-- Form Entry Tab -->
        
        <!-- Main Form Table -->
        <div class="form-table-section">
          <div class="table-scroll">
            <table class="I_Entry table table-bordered form-inline customTable table-custom-bg custom-table">
              <thead>
                <tr>
                  <th colspan="10">{{modalTitle}}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of scheduleKFormView.rows; track itemTracker(i, row); let i = $index) {
<tr 
                  class="formDataBlock" 
                 
                  [hidden]="row.num === '4a1' || row.num === '4b1' || row.num === '5a1' || row.num === '5b1'">
                  
                  <!-- Line Number -->
                  <td>{{row.num}}</td>
                  
                  <!-- Description and Input Fields -->
                  <td class="descBlock">
                    
                    <!-- Checkbox for specific lines (1a, 1b, 1c) -->
                    @if (row.num === '1a' || row.num === '1b' || row.num === '1c') {
<span>
                      <input 
                        type="checkbox" 
                        [checked]="row.value" 
                        [name]="row.num" 
                        [disabled]="isCheckboxDisabled(row.num)"
                        [(ngModel)]="row.value" 
                        (click)="onCheckboxChange(row.num, row.value, i)">
                    </span>
}
                    
                    <span>{{row.description}}</span>
                    
                    <!-- Checkbox for lines 11 and 8 -->
                    @if (row.num === '11' || row.num === '8') {
<span>
                      <input 
                        type="checkbox" 
                        [checked]="row.value" 
                        [name]="row.num" 
                        [(ngModel)]="row.value" 
                        (click)="fieldVisibility(i, row.value, '', '')">
                    </span>
}

                    <!-- Sub-table for 4a (Entities) -->
                    @if (row.num === '4a' && scheduleKFormView.rows[13]?.value === true) {
<div>
                      <table class="subTable custom-table">
                        <tr>
                          <th>(i) Name of Entity</th>
                          <th>(ii) Employer Identification Number (if any)</th>
                          <th>(iii) Type of Entity</th>
                          <th>(iv) Country of Organization</th>
                          <th>(v) Maximum Percentage Owned in Profit, Loss, or Capital</th>
                          <th class="addRowsColumn" style="background-color: #fff;">
                            <i class="fa fa-plus-circle color-green" (click)="addRows('entity', 13)"></i>
                          </th>
                        </tr>
                        @for (values of row.JSON_DATA; track $index; let idx = $index) {
<tr>
                          <td>
                            <input 
                              type="text" 
                              maxlength="75" 
                              [(ngModel)]="values.DATA_ATTRIB_A" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <input 
                              type="text" 
                              maxlength="9" 
                              [(ngModel)]="values.DATA_ATTRIB_B" 
                              (ngModelChange)="einValidation(values.DATA_ATTRIB_B, row.num)" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <input 
                              type="text" 
                              maxlength="1000" 
                              [(ngModel)]="values.DATA_ATTRIB_C" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <select 
                              [(ngModel)]="values.DATA_ATTRIB_D" 
                              class="form-control input-sm subtableRowHeight">
                              <option value="">Select Country</option>
                              @for (country of allCountries; track $index) {
<option 
                                
                                [value]="country.id">
                                {{country.label}}
                              </option>
}
                            </select>
                          </td>
                          <td>
                            <input 
                              type="number" 
                              class="form-control input-sm subtableRowHeight" 
                              [(ngModel)]="values.DATA_ATTRIB_E" 
                              (ngModelChange)="limitDecimal(values.DATA_ATTRIB_E, '4a', idx, 'DATA_ATTRIB_E')">
                          </td>
                          <td style="text-align: center;">
                            <i class="fa fa-minus-circle color-red" (click)="removeRow(i, idx)"></i>
                          </td>
                        </tr>
}
                      </table>
                      @if (row.JSON_DATA.length === 0) {
<div class="noRecordsBlock">
                        <span>No Records</span>
                      </div>
}
                    </div>
}

                    <!-- Sub-table for 4b (Individuals) -->
                    @if (row.num === '4b' && scheduleKFormView.rows[15]?.value === true) {
<div>
                      <table class="subTable custom-table">
                        <tr>
                          <th>(i) Name of Individual or Estate</th>
                          <th>(ii) Identifying Number (if any)</th>
                          <th>(iii) Country of Citizenship (see instructions)</th>
                          <th>(iv) Maximum Percentage Owned in Profit, Loss, or Capital</th>
                          <th class="addRowsColumn">
                            <i class="fa fa-plus-circle color-green" (click)="addRows('individual', 15)"></i>
                          </th>
                        </tr>
                        @for (values of row.JSON_DATA; track $index; let idx = $index) {
<tr [hidden]="row.JSON_DATA.length === 0">
                          <td>
                            <input 
                              type="text" 
                              maxlength="67" 
                              [(ngModel)]="values.DATA_ATTRIB_A" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <input 
                              type="text" 
                              maxlength="9" 
                              [(ngModel)]="values.DATA_ATTRIB_B" 
                              (ngModelChange)="einValidation(values.DATA_ATTRIB_B, row.num)" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <select 
                              [(ngModel)]="values.DATA_ATTRIB_C" 
                              class="form-control input-sm subtableRowHeight">
                              <option value="">Select Country</option>
                              @for (country of allCountries; track $index) {
<option 
                                
                                [value]="country.id">
                                {{country.label}}
                              </option>
}
                            </select>
                          </td>
                          <td>
                            <input 
                              type="number" 
                              class="form-control input-sm subtableRowHeight" 
                              [(ngModel)]="values.DATA_ATTRIB_D" 
                              (ngModelChange)="limitDecimal(values.DATA_ATTRIB_D, '4b', idx, 'DATA_ATTRIB_D')">
                          </td>
                          <td style="text-align: center;">
                            <i class="fa fa-minus-circle color-red" (click)="removeRow(i, idx)"></i>
                          </td>
                        </tr>
}
                      </table>
                      @if (row.JSON_DATA.length === 0) {
<div class="noRecordsBlock">
                        <span>No Records</span>
                      </div>
}
                    </div>
}

                    <!-- Sub-table for 5a (Corporations) -->
                    @if (row.num === '5a' && scheduleKFormView.rows[18]?.value === true) {
<div>
                      <table class="subTable custom-table">
                        <tr>
                          <th>(i) Name of Corporation</th>
                          <th>(ii) Employer Identification Number (if any)</th>
                          <th>(iii) Country of Incorporation</th>
                          <th>(iv) Percentage Owned in Voting Stock</th>
                          <th class="addRowsColumn" style="background-color: #fff;">
                            <i class="fa fa-plus-circle color-green" (click)="addRows('corporation', 18)"></i>
                          </th>
                        </tr>
                        @for (values of row.JSON_DATA; track $index; let idx = $index) {
<tr [hidden]="row.JSON_DATA.length === 0">
                          <td>
                            <input 
                              type="text" 
                              maxlength="67" 
                              [(ngModel)]="values.DATA_ATTRIB_A" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <input 
                              type="text" 
                              maxlength="9" 
                              [(ngModel)]="values.DATA_ATTRIB_B" 
                              (ngModelChange)="einValidation(values.DATA_ATTRIB_B, row.num)" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <select 
                              [(ngModel)]="values.DATA_ATTRIB_C" 
                              class="form-control input-sm subtableRowHeight">
                              <option value="">Select Country</option>
                              @for (country of allCountries; track $index) {
<option 
                                
                                [value]="country.id">
                                {{country.label}}
                              </option>
}
                            </select>
                          </td>
                          <td>
                            <input 
                              type="number" 
                              class="form-control input-sm subtableRowHeight" 
                              [(ngModel)]="values.DATA_ATTRIB_D" 
                              (ngModelChange)="limitDecimal(values.DATA_ATTRIB_D, '5a', idx, 'DATA_ATTRIB_D')">
                          </td>
                          <td style="text-align: center; border: none !important">
                            <i class="fa fa-minus-circle color-red" (click)="removeRow(i, idx)"></i>
                          </td>
                        </tr>
}
                      </table>
                      @if (row.JSON_DATA.length === 0) {
<div class="noRecordsBlock">
                        <span>No Records</span>
                      </div>
}
                    </div>
}

                    <!-- Sub-table for 5b (Other Entities) -->
                    @if (row.num === '5b' && scheduleKFormView.rows[20]?.value === true) {
<div>
                      <table class="subTable custom-table">
                        <tr>
                          <th>(i) Name of Entity</th>
                          <th>(ii) Employer Identification Number (if any)</th>
                          <th>(iv) Country of Organization</th>
                          <th>(v) Maximum Percentage Owned in Profit, Loss, or Capital</th>
                          <th class="addRowsColumn">
                            <i class="fa fa-plus-circle color-green" (click)="addRows('corporation', 20)"></i>
                          </th>
                        </tr>
                        @for (values of row.JSON_DATA; track $index; let idx = $index) {
<tr>
                          <td>
                            <input 
                              type="text" 
                              maxlength="75" 
                              [(ngModel)]="values.DATA_ATTRIB_A" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <input 
                              type="text" 
                              maxlength="9" 
                              [(ngModel)]="values.DATA_ATTRIB_B" 
                              (ngModelChange)="einValidation(values.DATA_ATTRIB_B, row.num)" 
                              class="form-control input-sm subtableRowHeight">
                          </td>
                          <td>
                            <select 
                              [(ngModel)]="values.DATA_ATTRIB_C" 
                              class="form-control input-sm subtableRowHeight">
                              <option value="">Select Country</option>
                              @for (country of allCountries; track $index) {
<option 
                                
                                [value]="country.id">
                                {{country.label}}
                              </option>
}
                            </select>
                          </td>
                          <td>
                            <input 
                              type="number" 
                              class="form-control input-sm subtableRowHeight" 
                              [(ngModel)]="values.DATA_ATTRIB_D" 
                              (ngModelChange)="limitDecimal(values.DATA_ATTRIB_D, '5b', idx, 'DATA_ATTRIB_D')">
                          </td>
                          <td style="text-align: center;">
                            <i class="fa fa-minus-circle color-red" (click)="removeRow(i, idx)"></i>
                          </td>
                        </tr>
}
                      </table>
                      @if (row.JSON_DATA.length === 0) {
<div class="noRecordsBlock">
                        <span>No Records</span>
                      </div>
}
                    </div>
}

                    <!-- Dropdown for line 2a -->
                    @if (row.num === '2a') {
<span>
                      <select 
                        id="system_chart" 
                        class="form-control" 
                        name="status" 
                        [(ngModel)]="scheduleKFormView.rows[5].value"
                        (ngModelChange)="updateColumnB(scheduleKFormView.rows[5].value)" 
                        required>
                        <option value="">Please Select</option>
                        @for (s of codeMastMap; track $index) {
<option 
                          
                          [value]="s.CODE_NAME">
                          {{s.CODE_DESC}}
                        </option>
}
                      </select>
                    </span>
}

                    <!-- Dropdown for line 7b -->
                    @if (row.num === '7b') {
<span>
                      <select 
                        [disabled]="row.conditionalField" 
                        id="system_chart" 
                        class="form-control" 
                        name="status" 
                        [(ngModel)]="scheduleKFormView.rows[25].value"
                        required>
                        <option value="">Please Select</option>
                        @for (s of allCountries; track $index) {
<option 
                          
                          [value]="s.id">
                          {{s.label}}
                        </option>
}
                      </select>
                    </span>
}

                    <!-- Text inputs for specific lines -->
                    @if (row.num === '3c') {
<input 
                     
                      type="text" 
                      maxlength="9" 
                      [disabled]="row.conditionalField" 
                      [(ngModel)]="row.value_user_input" 
                      [name]="row.num" 
                      (ngModelChange)="einValidation(row.value_user_input, row.num)" 
                      class="form-control input-sm">
}

                    @if (row.num === '2b') {
<input 
                     
                      type="text" 
                      [disabled]="true" 
                      [(ngModel)]="scheduleKFormView.rows[6].value" 
                      [name]="row.num" 
                      class="form-control input-sm">
}

                    <!-- Percentage inputs (7a, 7c, 26a, 26b) -->
                    @if (row.num === '7a' || row.num === '7c' || row.num === '26a' || row.num === '26b') {
<input 
                     
                      type="number"
                      min="0"
                      max="100"
                      [disabled]="row.conditionalField" 
                      [(ngModel)]="row.value_user_input" 
                      [name]="row.num" 
                      (ngModelChange)="limitDecimal($event, row.num, i, null)" 
                      class="form-control input-sm">
}

                    <!-- Regular number inputs (9, 10, 12, 13, 21, 25) -->
                    @if (row.num === '9' || row.num === '10' || row.num === '12' || row.num === '13' || row.num === '21' || row.num === '25') {
<input 
                     
                      type="number"
                      [disabled]="row.conditionalField" 
                      [(ngModel)]="row.value" 
                      [name]="row.num" 
                      class="form-control input-sm">
}

                    <!-- Regular text inputs (1c, 2c, 3a, 3b) -->
                    @if (row.num === '1c' || row.num === '2c' || row.num === '3a' || row.num === '3b') {
<input 
                     
                      type="text" 
                      [disabled]="row.conditionalField" 
                      [(ngModel)]="row.value_user_input" 
                      [name]="row.num" 
                      class="form-control input-sm">
}
                  </td>
                  
                  <!-- Yes/No Radio Buttons -->
                  <td align="right">
                    @if (['3', '4a', '4b', '5a', '5b', '6', '7', '13', '14', '15a', '15b', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '31', '29a', '29b', '29c', '30a', '30b', '30c'].includes(row.num)) {
<div>
                      <span style="vertical-align: text-bottom;">Yes </span>
                      <input 
                        type="radio" 
                        [name]="'radio_' + i + '_' + row.num" 
                        [value]="true"
                        [checked]="row.value === true"
                        (change)="onRadioChange(i, true, row)">
                      
                      <span style="margin-left: 4px; vertical-align: text-bottom;">No </span>
                      <input 
                        type="radio" 
                        [name]="'radio_' + i + '_' + row.num" 
                        [value]="false"
                        [checked]="row.value === false"
                        (change)="onRadioChange(i, false, row)">
                    </div>
}
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}
    </div>
  </div>
}
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>